import {
  isChatStreamPendingResumeError,
  singleFlightChatResume,
} from '@terra/shared-utils';
import { create } from 'zustand';

type ChatStreamResumeState = {
  resumingChatIds: Set<string>;
  setStreamResuming: (chatId: string, isResuming: boolean) => void;
  isStreamResuming: (chatId: string) => boolean;
};

export const useChatStreamResumeStore = create<ChatStreamResumeState>(
  (set, get) => ({
    resumingChatIds: new Set(),
    setStreamResuming: (chatId, isResuming) => {
      const next = new Set(get().resumingChatIds);

      if (isResuming) {
        next.add(chatId);
      } else {
        next.delete(chatId);
      }

      set({ resumingChatIds: next });
    },
    isStreamResuming: (chatId) => get().resumingChatIds.has(chatId),
  }),
);

export const singleFlightTrackedChatResume = ({
  chatId,
  resume,
}: {
  chatId: string;
  resume: () => void | Promise<void>;
}): Promise<void> =>
  singleFlightChatResume({
    chatId,
    resume,
    onError: (error) => {
      if (!isChatStreamPendingResumeError(error)) {
        useChatStreamResumeStore.getState().setStreamResuming(chatId, false);
      }
    },
  });
